import { useEffect, useState } from 'react'
import { useTokenStore } from 'stores/tokenStore'
import { useHealthTapStore } from 'modules/sleepNewLeads/State/healthTapStore'

// check if patient is logged in and skip the password page at the end of SNL
// exclude HealthTap
export const useSNLSkipPassword = () => {
  const { customerToken } = useTokenStore()
  const { healthtapSelected } = useHealthTapStore()

  const [ canSkipPassword, setCanSkipPassword ] = useState( false )

  useEffect( () => {
    if ( customerToken && !healthtapSelected ) {
      setCanSkipPassword( true )
    }
  }, [ customerToken, healthtapSelected ] )

  return {
    canSkipPassword
  }
}
